import { createFileRoute } from "@tanstack/react-router";
import CrpsTreatmentPage from "@/pages/CrpsTreatmentPage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute("/crps-treatment-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Crps Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "CRPS treatment in Coral Springs, FL. Ketamine therapy and supportive care for complex regional pain syndrome at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:title",
          content: "Crps Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "CRPS treatment in Coral Springs, FL. Ketamine therapy and supportive care for complex regional pain syndrome at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/crps-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/crps-treatment-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for CRPS Treatment Coral Springs, FL | Neuro Wellness",
              seoDescription:
                "Targeted IV Ketamine therapy for Complex Regional Pain Syndrome (CRPS) in Coral Springs, FL. Interrupt pain signals and rewire neural response at Neuro Wellness.",
              canonical: "/crps-treatment-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                { name: "CRPS", href: "/crps-treatment-coral-springs-fl" },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CrpsTreatmentPage />;
}
